<template>
  <div class="defaultPage">
    <img src="../../assets/img/image/noClass.png" alt="">
    <el-button @click="addClass">加入班级</el-button>
    <el-dialog title="加入班级" :close-on-click-modal="false" :visible.sync="dialogClassVisible" width="700px" :modal="false" :before-close="handleClassClose">
      <div class="class_box">
        <div class="image_box">
          <img v-if="icon && iocn !=null" :src="icon" alt="">
          <img v-else src="../../assets/images/user_img.png" alt="">
        </div>
        <p style="margin: 30px 0;">请输入您要加入的班级邀请码</p>
        <el-input style="width: 220px;" v-model="addCode" placeholder="请输入班级邀请码"></el-input>
      </div>
      <span slot="footer" class="dialog-footer" style="display: flex;justify-content: center;">
        <el-button @click="handleClassClose" size="medium">取 消</el-button>
        <el-button type="primary" size="medium" @click="confirmFn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogClassVisible: false,
      icon: localStorage.getItem("sIcon"),
      addCode: "",
    };
  },
  mounted() {
    if (localStorage.getItem("class_status") != 0) {
      this.$router.push("/qualityCourse/courseindex");
    }
  },
  methods: {
    addClass() {
      this.dialogClassVisible = true;
    },
    handleClassClose() {
      this.dialogClassVisible = false;
    },
    confirmFn() {
      if (!this.addCode) {
        this.$message.warning("邀请码不能为空");
        return;
      }
      this.$http.axiosPost(
        this.$api.jdJoinClass,
        { invitation_code: this.addCode },
        (res) => {
          if (res.code === 200) {
            this.$message.success("加入成功");
            localStorage.setItem("class_status", 1);
            this.$router.push("/qualityCourse/courseindex");
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "邀请码不正确",
          });
        }
      );
      this.dialogClassVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.defaultPage {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  padding-top: 100px;
  box-sizing: border-box;

  flex-direction: column;
  img {
    width: 200px;
    margin-bottom: 30px;
  }
  .el-button {
    width: 88px;
    height: 36px;
    background: #4f7bfd;
    border-radius: 4px 4px 4px 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
}

.class_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .image_box {
    width: 46px;
    height: 46px;
    border-radius: 4px;
    img {
      border-radius: 4px;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>